import {
  Directive,
  TemplateRef,
  ViewContainerRef,
  Input,
  inject,
  OnInit,
} from '@angular/core';
import { IdentityServiceBase } from '@seahorse/auth';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[shHasFeature]',
  standalone: true,
})
export class HasFeatureDirective implements OnInit {
  private _hasView = false;

  private _identity = inject(IdentityServiceBase);
  private _templateRef = inject(TemplateRef);
  private _viewContainer = inject(ViewContainerRef);

  @Input('shHasFeature') feature?: string;
  @Input('shHasFeatureNegate') negate = false;

  ngOnInit(): void {
    this.setUp();
  }

  private setUp() {
    if (!this.feature) {
      this.showContent();
      return;
    }

    const showContent = this.negate
      ? !this._identity.hasFeature(this.feature)
      : this._identity.hasFeature(this.feature);

    if (showContent && !this._hasView) {
      this.showContent();
      return;
    }

    if (!showContent && this._hasView) {
      this.hideContent();
      return;
    }
  }

  private showContent() {
    this._viewContainer.createEmbeddedView(this._templateRef);
    this._hasView = true;
  }

  private hideContent() {
    this._viewContainer.clear();
    this._hasView = false;
  }
}
